import { cn } from '@/lib/utils';
import { FX_BY_ID } from '@/lib/channelEffects';

/**
 * Discord-style per-channel decoration — a small cluster of animated glyphs that
 * float just above a channel row. Chosen in the Theme Studio (see
 * `@/lib/channelEffects`) and rendered both there and in the live community rail,
 * so the effect is real + persistent. Renders `null` for "none".
 */
export function ChannelFx({ effect, className }: { effect: string | null | undefined; className?: string }) {
  const fx = effect ? FX_BY_ID[effect] : undefined;
  if (!fx || fx.id === 'none' || !fx.emoji) return null;
  return (
    <span
      aria-hidden
      className={cn('pointer-events-none absolute -top-1 left-7 z-10 flex gap-[3px] text-[9px] leading-none', className)}
    >
      {[0, 1, 2].map((i) => (
        <span key={i} className={fx.anim} style={{ animationDelay: `${i * 0.2}s` }}>
          {fx.emoji}
        </span>
      ))}
    </span>
  );
}
